import context from '@truckdown/components-systems';

import './Styles/custom.less';
import './Components';

import './Images/developer_api_header.png';
import './Images/integrations_screen.png';
import './Images/webhooks_verification1.png';
import './Images/webhooks_verification2.png';
import './Images/slack_createapp.png';
import './Images/slack_createchannel1.png';
import './Images/slack_createwebhook.png';
import './Images/slack_webhookurl.png';
import './Images/slack_registerwebhook.png';
import './Images/teams_channels.png';
import './Images/teams_webhookworkflow.png';
import './Images/teams_registerwebhook.png';


context.initialize().then(() => {
    console.log('System initialized');
});